import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ClearToastData } from './actions'
import { Snackbar } from 'react-native-paper'

const colors = {
  info: '#0083CE',
  warning: '#F6A15B',
  success: '#56B158',
  error: '#FA2E2E'
}

const ToastContainer = () => {
  const dispatch = useDispatch()
  const { type, message } = useSelector(state => state.toastReducer)

  const onDismissSnackBar = () => dispatch(ClearToastData())

  return (
    <Snackbar
      testID='notification'
      accessibilityLabel='notification'
      visible={Boolean(message)}
      onDismiss={onDismissSnackBar}
      style={{ backgroundColor: colors[type] || colors.info }}
      duration={3000}
      wrapperStyle={{
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'flex-start'
      }}
    >
      {message}
    </Snackbar>
  )
}

export default ToastContainer
